import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LOGIN } from "@/constants/testIds/auth";
import { ADMIN } from "@/constants/testIds/waitlist";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain min-h-screen bg-muted grid place-items-center px-6" data-testid={ADMIN.loginPage}>
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-border rounded-lg p-8 space-y-5">
        <div>
          <Link to="/" className="font-display text-xl">Archana <span className="italic text-primary">Relationship</span> School</Link>
          <h1 className="font-display text-3xl mt-4">Waitlist admin</h1>
          <p className="text-sm text-muted-foreground mt-1">Sign in to see and download signups.</p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="admin-email">Email</Label>
          <Input id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11" data-testid={LOGIN.emailInput} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="admin-password">Password</Label>
          <Input id="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-11" data-testid={LOGIN.passwordInput} />
        </div>
        {error && <p role="alert" className="text-sm text-destructive" data-testid={ADMIN.loginError}>{error}</p>}
        <Button type="submit" disabled={busy} className="btn-lift w-full h-11 bg-primary hover:bg-primary/90" data-testid={LOGIN.submitButton}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
        </Button>
      </form>
    </div>
  );
}
